var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.currentTime)))]),_c('img',{staticClass:"logo",attrs:{"src":"/img/svg/FeuchterStiftungLogo.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }